import React from 'react';
import PropTypes from 'prop-types';
import Toast from "../../../../../components/WMS/Toast";
import ErrorIcon from "assets/img/error.svg"
import ValidatedIcon from "assets/img/validated.svg"
import {FormattedMessage} from "react-intl";

PackingToast.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    type: PropTypes.oneOf([
        "error",
        "printSuccess",
        "articleDropSuccess",
        "allCancelled",
        "pack_item",
        "wrongItemScanned",
        "omniScanWrongItem",
        "omniScanWrongContainer",
        "omniScanNotFound"
    ]),
    isTop: PropTypes.bool
};

function PackingToast({open, handleClose, type, isTop}) {
    if (open) {
        switch (type) {
            case "error":
                return(
                    <Toast
                        icon={<img style={{height: '20px', width: '20px'}} src={ErrorIcon} alt={"error-icon"}/>}
                        title={<FormattedMessage id={"wms.packing.toast.error.title"}/>}
                        subtitle={<FormattedMessage id={"wms.packing.toast.error.subtitle"}/>}
                        open={open}
                        handleClose={() => handleClose()}
                        isTop={isTop}
                    />
                )
            case "printSuccess":
                return(
                    <Toast
                        icon={<img style={{height: '20px', width: '20px'}} src={ValidatedIcon} alt={"validated-icon"}/>}
                        title={<FormattedMessage id={"wms.packing.toast.printSuccess.title"}/>}
                        open={open}
                        handleClose={() => handleClose()}
                        isTop={isTop}
                    />
                )
            case "articleDropSuccess":
                return (
                    <Toast
                        icon={<img style={{height: '20px', width: '20px'}} src={ValidatedIcon} alt={"validated-icon"}/>}
                        title={<FormattedMessage id={"wms.packing.toast.articleDropSuccess.title"}/>}
                        open={open}
                        handleClose={() => handleClose()}
                        isTop={isTop}
                    />
                )
            case "allCancelled":
                return (
                    <Toast
                        icon={<img style={{height: '20px', width: '20px'}} src={ErrorIcon} alt={"validated-icon"}/>}
                        title={<FormattedMessage id={"wms.packing.toast.allCancelled.title"}/>}
                        subtitle={<FormattedMessage id={"wms.packing.toast.allCancelled.subtitle"}/>}
                        open={open}
                        handleClose={() => handleClose()}
                        isTop={isTop}
                    />
                )
            // When packing start
            case "pack_item":
                return (
                    <Toast
                        icon={<img style={{height: '20px', width: '20px'}} src={ValidatedIcon} alt={"validated-icon"}/>}
                        title={<FormattedMessage id={"wms.packing.toast.pack_item.title"}/>}
                        subtitle={<FormattedMessage id={"wms.packing.toast.pack_item.subtitle"}/>}
                        open={open}
                        handleClose={() => handleClose()}
                        isTop={isTop}
                    />
                )
            case "wrongItemScanned":
                return (
                    <Toast
                        open={open}
                        handleClose={handleClose}
                        title={<FormattedMessage id={"wms.packing.toast.wrongItemScanned.title"}/>}
                        subtitle={<FormattedMessage id={"wms.packing.toast.wrongItemScanned.subtitle"}/>}
                        icon={<img style={{height: '20px', width: '20px'}} src={ErrorIcon} alt={"error-icon"}/>}
                        isTop={isTop}
                    />
                )
            case "omniScanWrongItem":
                return (
                    <Toast
                        open={open}
                        handleClose={handleClose}
                        title={<FormattedMessage id={"wms.packing.toast.omniScan.wrongItem.title"}/>}
                        subtitle={<FormattedMessage id={"wms.packing.toast.omniScan.wrongItem.subtitle"}/>}
                        icon={<img style={{height: '20px', width: '20px'}} src={ErrorIcon} alt={"error-icon"}/>}
                        isTop={isTop}
                    />
                )
            case "omniScanWrongContainer":
                return (
                    <Toast
                        open={open}
                        handleClose={handleClose}
                        title={<FormattedMessage id={"wms.packing.toast.omniScan.wrongContainer.title"}/>}
                        subtitle={<FormattedMessage id={"wms.packing.toast.omniScan.wrongContainer.subtitle"}/>}
                        icon={<img style={{height: '20px', width: '20px'}} src={ErrorIcon} alt={"error-icon"}/>}
                        isTop={isTop}
                    />
                )
            case "omniScanNotFound":
                return (
                    <Toast
                        open={open}
                        handleClose={handleClose}
                        title={<FormattedMessage id={"wms.packing.toast.omniScan.notFound.title"}/>}
                        subtitle={<FormattedMessage id={"wms.packing.toast.omniScan.notFound.subtitle"}/>}
                        icon={<img style={{height: '20px', width: '20px'}} src={ErrorIcon} alt={"error-icon"}/>}
                        isTop={isTop}
                    />
                )
            // When a workstation is already scanned in PACKING step and we don't force the workstation scan
            case "noWorkstationScanBeginPacking":
                return (
                    <Toast
                        open={open}
                        handleClose={handleClose}
                        title={<FormattedMessage id={"wms.packing.toast.noWorkstationScan.title"}/>}
                        subtitle={<FormattedMessage id={"wms.packing.toast.noWorkstationScan.subtitle"}/>}
                        icon={<img style={{height: '20px', width: '20px'}} src={ValidatedIcon} alt={"valid-icon"}/>}
                        isTop={isTop}
                    />
                )
            // When scanning a workstation during PEEK step
            case "workstationScanned":
                return (
                    <Toast
                        open={open}
                        handleClose={handleClose}
                        title={<FormattedMessage id={"wms.packing.toast.workstationScanned.title"}/>}
                        icon={<img style={{height: '20px', width: '20px'}} src={ValidatedIcon} alt={"valid-icon"}/>}
                        isTop={isTop}
                    />
                )
            default:
                return (
                    <></>
                )
        }
    }
}

export default PackingToast;